// extracted by mini-css-extract-plugin
export default {"icon-trash":"ProductsListLoadMore_icon-trash__g6-oz"};